/* global context */
/* pricing */
// TODO: EUR
const monthlyPrice = 29.99;
const monthlyBillingId = 'monthly_unlimited_2020';

export const CONTIUNITY_PLAN_BILLING_ID = 'monthly_maintenance_2020';
export const CONTIUNITY_PLAN_BILLING_ID_EUR = 'continuity-EUR-Monthly';
export const CONTIUNITY_PLAN_BILLING_ID_GBP = 'continuity-GBP-Monthly';
export const MONTHLY_BILLING_ID = 'monthly_unlimited_2020';
export const MONTHLY_BILLING_ID_EUR = 'motionarray_unlimited-EUR-Monthly';
export const MONTHLY_BILLING_ID_GBP = 'motionarray_unlimited-GBP-Monthly';
export const ANNUAL_BILLING_ID = 'yearly_unlimited_2020';
export const ANNUAL_BILLING_ID_EUR = 'motionarray_unlimited-EUR-Yearly';
export const ANNUAL_BILLING_ID_GBP = 'motionarray_unlimited-GBP-Yearly';
export const PLAN_YEARLY_270_ID = 'yearly_270';
export const BUSINESS_BILLING_ID = 'team_yearly_enterprise';
export const YEARLY_270_BILLING_ID = 'yearly_270';
export const YEARLY_251_88_BILLING_ID = 'yearly_251_88';
export const TEAM_BILLING_ID = 'team_yearly_10_percent_discount';
export const TEAM_BILLING_ID_EUR = 'team_plan-EUR-Yearly';
export const TEAM_BILLING_ID_GBP = 'team_plan-GBP-Yearly';
export const TEAM_BUSINESS_BILLING_ID = 'team_business_50_plus-USD-Yearly';
export const TEAM_BUSINESS_BILLING_ID_EUR = 'team_business_50_plus-EUR-Yearly';
export const TEAM_BUSINESS_BILLING_ID_GBP = 'team_business_50_plus-GBP-Yearly';
export const YEARLY_EVERYTHING_TEAMS_BILLING_ID = 'everything_teams-USD-Yearly';
export const YEARLY_EVERYTHING_TEAMS_BILLING_ID_EUR = 'everything_teams-EUR-Yearly';
export const YEARLY_EVERYTHING_TEAMS_BILLING_ID_GBP = 'everything_teams-GBP-Yearly';
export const YEARLY_AI_VOICEOVER_150K_BILLING_ID = 'VO-AI-voiceover-150K-USD-Yearly';
export const YEARLY_AI_VOICEOVER_150K_BILLING_ID_EUR = 'VO-AI-voiceover-150K-EUR-Yearly';
export const YEARLY_AI_VOICEOVER_150K_BILLING_ID_GBP = 'VO-AI-voiceover-150K-GBP-Yearly';
export const YEARLY_AI_VOICEOVER_200K_BILLING_ID = 'VO-AI-voiceover-200K-USD-Yearly';
export const YEARLY_AI_VOICEOVER_200K_BILLING_ID_EUR = 'VO-AI-voiceover-200K-EUR-Yearly';
export const YEARLY_AI_VOICEOVER_200K_BILLING_ID_GBP = 'VO-AI-voiceover-200K-GBP-Yearly';
export const YEARLY_AI_VOICEOVER_100K_BILLING_ID = 'VO-AI-voiceover-100K-USD-Yearly';
export const YEARLY_AI_VOICEOVER_100K_BILLING_ID_EUR = 'VO-AI-voiceover-100K-EUR-Yearly';
export const YEARLY_AI_VOICEOVER_100K_BILLING_ID_GBP = 'VO-AI-voiceover-100K-GBP-Yearly';
export const YEARLY_AI_VOICEOVER_50K_BILLING_ID = 'VO-AI-voiceover-50K-USD-Yearly';
export const YEARLY_AI_VOICEOVER_50K_BILLING_ID_EUR = 'VO-AI-voiceover-50K-EUR-Yearly';
export const YEARLY_AI_VOICEOVER_50K_BILLING_ID_GBP = 'VO-AI-voiceover-50K-GBP-Yearly';
export const YEARLY_EVERYTHING_BILLING_ID = 'everything-USD-Yearly';
export const YEARLY_EVERYTHING_BILLING_ID_EUR = 'everything-EUR-Yearly';
export const YEARLY_EVERYTHING_BILLING_ID_GBP = 'everything-GBP-Yearly';
export const MONTHLY_EVERYTHING_BILLING_ID = 'everything-USD-Monthly';
export const MONTHLY_EVERYTHING_BILLING_ID_EUR = 'everything-EUR-Monthly';
export const MONTHLY_EVERYTHING_BILLING_ID_GBP = 'everything-GBP-Monthly';
export const VO_AI_VOICEOVER_BUSINESS_USD_YEARLY = 'VO-AI-voiceover-Business-USD-Yearly';
export const VO_AI_VOICEOVER_BUSINESS_EUR_YEARLY = 'VO-AI-voiceover-Business-EUR-Yearly';
export const VO_AI_VOICEOVER_BUSINESS_GBP_YEARLY = 'VO-AI-voiceover-Business-GBP-Yearly';
export const YEARLY_TEMPLATES_ID = 'Templates-USD-Yearly';
export const YEARLY_TEMPLATES_EUR = 'Templates-EUR-Yearly';
export const YEARLY_TEMPLATES_GBP = 'Templates-GBP-Yearly';
export const MONTHLY_TEMPLATES_ID = 'Templates-USD-Monthly';
export const MONTHLY_TEMPLATES_EUR = 'Templates-EUR-Monthly';
export const MONTHLY_TEMPLATES_GBP = 'Templates-GBP-Monthly';
export const BUSINESS_PLAN_USD_YEARLY = 'Business-Plan-USD-Yearly';
export const BUSINESS_PLAN_EUR_YEARLY = 'Business-Plan-EUR-Yearly';
export const BUSINESS_PLAN_GBP_YEARLY = 'Business-Plan-GBP-Yearly';

export const PRICING_SINGLE_PLANS = [
  {
    id: 'free',
    name: 'Free',
    price: 0,
    billing_id: 'free',
  },
  {
    id: 'monthly',
    name: 'Monthly',
    price: monthlyPrice,
    billing_id: monthlyBillingId,
  },
  {
    id: 'annual',
    name: 'Annual',
    price: 249.99,
    // price: 199.99,
    billing_id: 'yearly_unlimited_2020',
    ab_discount: 10.11,
  },
  {
    id: PLAN_YEARLY_270_ID,
    name: 'Annual',
    price: 270,
    billing_id: PLAN_YEARLY_270_ID,
  },
  {
    id: 'continuity',
    name: 'Continuity',
    price: 9.99,
    billing_id: CONTIUNITY_PLAN_BILLING_ID,
  },
];

export const PRICING_TEAM_PLAN = {
  price: 224.99, // discounted price
  original_price: 249.99, // original price
  billing_id: 'team_yearly_10_percent_discount',
};

export const initialRemainingDLPopup = 3;

export const CATEGORY_SLUG_TO_CATEGORY_TYPE_MAP = {
  'after-effects-templates': 'Templates',
  'premiere-pro-templates': 'Templates',
  'motion-graphics-templates': 'Templates',
  'davinci-resolve-templates': 'Templates',
  'premiere-rush-templates': 'Templates',
  'davinci-resolve-macros': 'Templates',
  'final-cut-pro-templates': 'Templates',
  'premiere-pro-presets': 'Presets',
  'after-effects-presets': 'Presets',
  'royalty-free-music': 'Audio',
  'sound-effects': 'Audio',
  'stock-video': 'Videos',
  'stock-motion-graphics': 'Videos',
  'stock-photos': 'Images',
};

export const PAYMENT_PROVIDERS = {
  STRIPE: 'stripe',
  PAYPAL: 'paypal',
  ADYEN: 'adyen',
  GOOGLEPAY: 'google_pay',
  APPLEPAY: 'apple_pay',
};
export const CREDIT_CARD_PROVIDERS = [PAYMENT_PROVIDERS.STRIPE, PAYMENT_PROVIDERS.ADYEN];

export const PAYMENT_METHOD_TYPES = {
  CREDITCARD: 'credit card',
  PAYPAL: 'paypal',
  PAYPAL_EXPRESS_CHECKOUT: 'paypal_express_checkout',
  GOOGLEPAY: 'google_pay',
  APPLEPAY: 'apple_pay',
};
export const PAYMENT_METHODS = {
  ORIGINAL: 'original',
  CHARGEBEE: 'chargebee',
};

/* Define constants */
export const MEMBER_CATEGORY = {
  MEMBERS: 'members',
  ADMINS: 'admins',
  PENDING: 'pending',
};

/* account/team */
export const TEAM_MANAGER_TABS = [
  {
    name: 'MEMBERS',
    id: MEMBER_CATEGORY.MEMBERS,
  },
  {
    name: 'ADMINS',
    id: MEMBER_CATEGORY.ADMINS,
  },
  {
    name: 'PENDING',
    id: MEMBER_CATEGORY.PENDING,
  },
];

export const TEAM_MANAGER_EDIT_MENU = {
  allocate_seat: {
    id: 'allocate_seat',
    name: 'Allocate Seat',
    action: 'allocateSeat',
    confirm: {
      title: 'Allocate Seat?',
      description: 'Do you want to make <%name%> allocated seat?',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['active', 'pending'],
    is_admin: null,
  },
  remove_seat: {
    id: 'remove_seat',
    name: 'Remove Seat',
    action: 'removeSeat',
    confirm: {
      title: 'Remove Seat?',
      description: 'Do you want to make <%name%> removed seat?',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['active', 'pending'],
    is_admin: null,
  },
  make_admin: {
    id: 'make_admin',
    name: 'Make Admin',
    action: 'makeAdmin',
    confirm: {
      title: 'Make Admin?',
      description: 'Do you want to make <%name%> an Admin?',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['active'],
    is_admin: false,
  },
  remove_admin: {
    id: 'remove_admin',
    name: 'Remove Admin',
    action: 'removeAdmin',
    confirm: {
      title: 'Remove Admin?',
      description: 'Do you want to make <%name%> a Non-admin?',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['active'],
    is_admin: true,
  },
  resend_invite: {
    id: 'resend_invite',
    name: 'Resend Invite',
    action: 'resendInvite',
    confirm: {
      title: 'Resend Invite?',
      description: 'Do you want to send an invite again?',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['pending'],
    is_admin: false,
  },
  remove_from_team: {
    id: 'remove_from_team',
    name: 'Remove From Team',
    action: 'removeFromTeam',
    confirm: {
      title: 'Remove Members?',
      // eslint-disable-next-line max-len
      description:
        'The team slot will remain active. A new member can be added to this slot at no additional cost through this billing cycle.',
      yes: 'Confirm',
      no: 'Cancel',
    },
    status: ['active', 'pending'],
    is_admin: null,
  },
};

/* price of a seat - $(usd) */
export const SEAT_PRICE = 224.99;
export const CATEGORY_ASSET_META_TITLE = {
  'after-effects-templates': 'an After Effects template',
  'premiere-pro-templates': 'a Premiere Pro template',
  'motion-graphics-templates': 'a Motion Graphics template',
  'premiere-rush-templates': 'an Adobe Premiere Rush template',
  'davinci-resolve-templates': 'a DaVinci Resolve template',
  'final-cut-pro-templates': 'a Final Cut Pro template',
  'after-effects-presets': 'an Adobe After Effects preset',
  'premiere-pro-presets': 'an Adobe Premiere Pro preset',
  'davinci-resolve-macros': 'a DaVinci Resolve Macro preset',
  'royalty-free-music': 'a royalty-free music asset',
  'sound-effects': 'one of several sound effects produced',
  'stock-video': 'a stock footage asset produced',
  'stock-motion-graphics': 'a stock Motion Graphic template',
  'stock-photos': 'a stock photo asset',
  graphics: '',
};

export const CATEGORY_ASSET_META_TEXT_DETAILS = {
  'after-effects-templates': 'collection of After Effects templates',
  'premiere-pro-templates': 'collection of Premiere Pro Templates',
  'motion-graphics-templates': 'collection of Motion Graphics templates',
  'premiere-rush-templates': 'collection of Premiere Rush templates',
  'davinci-resolve-templates': 'collection of DaVinci Resolve templates',
  'final-cut-pro-templates': 'collection of Final Cut Pro templates',
  'after-effects-presets': 'collection of digital assets',
  'premiere-pro-presets': 'collection of digital assets',
  'davinci-resolve-macros': 'collection of digital assets',
  'royalty-free-music': 'vast collection of stock music',
  'sound-effects': 'vast collection of SFX',
  'stock-video': 'vast collection of stock videos',
  'stock-motion-graphics': 'collection of digital assets',
  'stock-photos': 'collection of unique stock photos',
  graphics: '',
};

export const SEARCH_TYPES = {
  GLOBAL_SEARCH: 'globalSearch',
  CATEGORY_SEARCH: 'categorySearch',
  RELATED_SEARCH: 'relatedSearch',
};

export const SEARCH_LOCAL_STORAGE_TYPES = {
  SEARCH_STATE: 'search-state',
};

export const AB_TEST_VERSION = {
  A: 'A',
  B: 'B',
  C: 'C',
};

export const SESSION_NAMES = {
  IS_DUNNING_POPUP_CLOSED: 'isDunningPopupClosed',
  IS_DUNNING_SNACKBAR_CLOSED: 'isDunningSnackbarClosed',
};

export * from './cookies';
export const MAX_NAME_LENGTH = 150;
export const MAX_FULL_NAME_LENGTH = 300;
export const MAX_EMAIL_LENGTH = 70;
export const MAX_BILLING_ADDRESS_LENGTH = 150;
export const MAX_BILLING_CITY_LENGTH = 50;
export const MAX_ZIP_CODE_LENGTH = 20;
export const AUSTRALIA_COUNTRY_CODE = 'AU';
export const ABN_NUMBER_LENGTH = 11;
export const ABN = 'ABN';
export const VAT_ID_EU_NUMBER_MIN = 8;
export const VAT_ID_EU_NUMBER_MAX = 14;

export const SESSION_MAIN_SEARCH = 'mainSearchData';

export * from './search-categories';

// move to subscription constants
export const AVALARA_MESSAGE = 'Unable to calculate the tax rates';
export const VAT_CALCULATION_MESSAGE = ' is calculated according to your billing address';
export const USA_COUNTRY_CODE = 'US';
export const VAT_ID_NOT_VALID = 'vatIdNotValid';
export const ESTIMATED_PRICE_ERROR_MESSAGES = ['UsAddressNotValid'];
export const INTERNAL_ERROR_MESSAGE = 'Billing address is not valid';

export const ALERT_TYPES = {
  ERROR: 'error',
};

export const VAT_ID_LABEL = {
  VAT: 'VAT ID',
  GST: 'GST',
  ABN: 'ABN',
  TAX: 'Tax',
  SALES_TAX: 'Sales tax',
};

export const VAT_ID_ERROR_MESSAGE = {
  ABN_LENGTH: 'Enter your 11-digit ABN',
  VAT_NUMBER_INVALID: "Couldn't verify VAT ID. VAT will be included in your bill.",
  VAT_ID_LENGTH: 'Enter a valid VAT ID',
  ABN_NUMBER_INVALID: "Couldn't verify ABN. GST will be included in your bill.",
};
export const VAT_ABN_TOOLTIP_MESSAGE =
  'Tax may be added to your next payment based on the validity of your ABN';

export const VAT_EU_TOOLTIP_MESSAGE =
  "Enter a valid European Union VAT identification number for the 'Reverse Charge' mechanism to apply";

export const USER_LEAD_TYPE = {
  PL: 'PL',
  SQL: 'SQL',
};

// timeout value provided by enterprise team
export const TYPE_FORM_TIMEOUT = 6000;

export const isProductionEnv = process.env.MIX_APP_ENV === 'production';

export const TYPE_FORM_ID = {
  PL_JOURNEY: isProductionEnv ? 'TXMjCUVz' : 'nMQy09t1',
  ENTERPRISE: isProductionEnv ? 'hU5WRYnx' : 'hmCeIrBL',
};

export const USER_PLAN = {
  FREE: 'Free',
  MONTHLY: 'Monthly',
  ANNUAL: 'Annual',
  TEAM: 'Team',
  CONTINUITY: 'Continuity',
  BUSINESS: 'Business',
  YEARLY_AI_VOICEOVER_50K: 'VO AI voiceover 50K Yearly',
  YEARLY_AI_VOICEOVER_100K: 'VO AI voiceover 100K Yearly',
  YEARLY_AI_VOICEOVER_150K: 'VO AI voiceover 150K Yearly',
  EVERYTHING_MONTHLY: 'Everything Monthly',
  EVERYTHING_YEARLY: 'Everything Yearly',
  EVERYTHING_TEAMS: 'Everything Teams Yearly',
  TEMPLATES_YEARLY: 'Video Templates Yearly',
  TEMPLATES_MONTHLY: 'Video Templates Monthly',
};

export const USER_PLAN_URLS = {
  [USER_PLAN.FREE]: 'free',
  [USER_PLAN.MONTHLY]: 'monthly',
  [USER_PLAN.ANNUAL]: 'annual',
  [USER_PLAN.TEAM]: 'team',
  [USER_PLAN.CONTINUITY]: 'continuity',
  [USER_PLAN.BUSINESS]: 'business',
  [USER_PLAN.YEARLY_AI_VOICEOVER_50K]: 'voiceover-50',
  [USER_PLAN.YEARLY_AI_VOICEOVER_100K]: 'voiceover-100',
  [USER_PLAN.YEARLY_AI_VOICEOVER_150K]: 'voiceover-150',
  [USER_PLAN.EVERYTHING_YEARLY]: 'everything-yearly',
  [USER_PLAN.EVERYTHING_MONTHLY]: 'everything-monthly',
  [USER_PLAN.EVERYTHING_TEAMS]: 'teams',
  [USER_PLAN.TEMPLATES_YEARLY]: 'templates-yearly',
  [USER_PLAN.TEMPLATES_MONTHLY]: 'templates-monthly',
};

export const UPGRADE_TO_PLAN_URLS = {
  [USER_PLAN.EVERYTHING_TEAMS]: 'everything-teams',
};

export const BUSINESS_CONTACT_FROM_URL =
  'https://forms.monday.com/forms/f0fd5ab0bf1b53ab00a6ac21abc5d738?r=use1';

export const EURO_VAT_ENABLED_COUNTRIES = [
  'AT',
  'BE',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FI',
  'FR',
  'DE',
  'GR',
  'HU',
  'IE',
  'IT',
  'LV',
  'LT',
  'LU',
  'MT',
  'NL',
  'PL',
  'PT',
  'RO',
  'SK',
  'SI',
  'ES',
  'SE',
];
